import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useRef } from 'react';
import { useOnClickOutside } from '@flywire/react-hooks';
import { ESCAPE } from '../../constants';
import { Content } from './Content';
import { Context, Provider } from './Context';
import { Trigger } from './Trigger';
const TooltipComponent = forwardRef(({ as: Element = 'div', children, className }, forwardedRef) => {
    const internalRef = useRef(null);
    const { id, isOpen, setIsOpen } = useContext(Context);
    useImperativeHandle(forwardedRef, () => internalRef.current);
    useOnClickOutside(internalRef, useCallback(() => setIsOpen(false), [setIsOpen]));
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === ESCAPE && isOpen) {
                setIsOpen(false);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, setIsOpen]);
    return (_jsx(Element, { ref: internalRef, className: className, "data-state": isOpen ? 'open' : null, role: "tooltip", id: id, children: children }));
});
TooltipComponent.displayName = 'Tooltip';
const Wrapper = forwardRef(({ as = 'div', className, id, children, position = 'top', ...rest }, ref) => {
    return (_jsx(Provider, { id: id, position: position, ...rest, children: _jsx(TooltipComponent, { as: as, ref: ref, className: className, children: children }) }));
});
Wrapper.displayName = 'Tooltip';
const Tooltip = Wrapper;
Tooltip.displayName = 'Tooltip';
Tooltip.Trigger = Trigger;
Tooltip.Content = Content;
export { Tooltip };
//# sourceMappingURL=Tooltip.js.map